module.exports = "data:image/gif;base64,R0lGODlhEAAQAJEBAAAAAAAAAP///wAAACH5BAEAAAEALAAAAAAQABAAAAIejI+py50Ao4QIOHsw04Er7j3VNTYgmaHGxIbOC78FADs="